import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
// Google Analytics
import tracker from 'actions/tracking';
// support for tap events on mobile
import injectTapEventPlugin from 'react-tap-event-plugin';
// polyfills to shim for various browser APIs (mostly IE)
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/map';
import 'core-js/es6/weak-map';
// the dashboard container that includes all of the components
import Main from 'scripts/Main';
import {GlobalStore} from 'reducers/configureStore'

// URL origins for fetching remote data
import { setOriginUrls, getAnalyticsConfigJSON, setAnalyticsConfig, setOriginUrlstoConfig, UrlInfo } from 'actions/config';

// global CSS
import 'styles/index.css';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

// initialize google analytics
tracker.init();

document.addEventListener('DOMContentLoaded', function(){
	getAnalyticsConfigJSON()
		.then((json)=>{setAnalyticsConfig(json)})
		.then(setOriginUrlstoConfig)
		.then(setOriginUrls)// initialize origin URLs for fetching remote data
		.then(init)
		.catch((error)=>{console.error(error); init(); });
}, false);

// DOMContentLoaded is fired when initial HTML is completely loaded, but before CSS, images, & subframes
// https://developer.mozilla.org/en/docs/Web/Events/DOMContentLoaded
function init () {
	ReactDOM.render(
		<Provider store={GlobalStore}>
		{/*log initial load*/}
			<Router >
				<div>
				{/* dashboard container */}
				<Route exact path="/:clientId/:userId" component={Main}/>
				</div>
			</Router>
		</Provider>
		,
		document.getElementById('analyticsRoot')
	);
}



// WEBPACK FOOTER //
// ./src/index.js